import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from '@blueprintjs/core'

import './Table.scss'

const typeRenders = {
  value: value => value,
  tick: value => value ? <Icon iconName="tick"/> : null
}

function Table({ children, data }) {
  let cols = React.Children.toArray(children)
  let headers = cols.map(col => col.props.title)
  let cells = cols.map(({props}) => {
    let { type, field } = props
    type = type || 'value'
    return {
      empty: null,
      render: (d) => typeRenders[type](d[field]),
      ...props,
    }
  })
  return (
    <table className="pt-table pt-striped pt-interactive" width="100%">
      <thead>
        {headers.map((header, idx) => <th key={idx}>{header}</th>)}
      </thead>
      <tbody>
        {data.map((d, idx) => (
          <tr key={idx}>
            {cells.map(({ render, empty }, idx) => <td key={idx}>{render(d)||empty}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

Table.propTypes = {
  children: PropTypes.node,
  data: PropTypes.array,
  type: PropTypes.string,
  field: PropTypes.string,
}

export function Col() {
  return null
}

export default Table



/** WEBPACK FOOTER **
 ** ./client/components/blueprint/Table.js
 **/